interface Environment {
  API_URL: string
  MIXPANEL_TOKEN?: string
  GOOGLE_ANALYTICS_ID?: string
  ENVIRONMENT: 'development' | 'staging' | 'production'
  FEATURES: {
    DEBUG_MODE: boolean
    MAINTENANCE_MODE: boolean
    ANALYTICS_ENABLED: boolean
    NGROK_ENABLED: boolean
  }
}

export const environment: Environment = {
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:8000',
  MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN,
  GOOGLE_ANALYTICS_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  ENVIRONMENT: (import.meta.env.VITE_ENV as Environment['ENVIRONMENT']) || 'development',
  FEATURES: {
    DEBUG_MODE: import.meta.env.DEV,
    MAINTENANCE_MODE: import.meta.env.VITE_MAINTENANCE_MODE === 'true',
    ANALYTICS_ENABLED: import.meta.env.VITE_ANALYTICS_ENABLED === 'true',
    NGROK_ENABLED: import.meta.env.VITE_USE_NGROK === 'true',
  }
}

export const isProduction = environment.ENVIRONMENT === 'production'
export const isDevelopment = environment.ENVIRONMENT === 'development'
export const isStaging = environment.ENVIRONMENT === 'staging' 